// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Modal,
  Form,
  Table
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { Redirect, Link } from "react-router-dom";
import { withRouter } from "react-router";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "./dashboard.scss";
import {
  currentDealList, upcomingDealList, subscribeUser
} from "../../../redux/actions/frontActions";
import {getSiteStatus}    from '../../../redux/actions/siteActions';
import logo from "../../../img/ddb-logo.png";
import bannerImg from "../../../img/2006380_YyczUn.png";
import noImg from "../../../img/no_img.jpg";
import dealImg from "../../../img/Deal-Photo.jpg";
import noRecordFound from "../../../img/no-record-found.png";
import "react-responsive-tabs/styles.css";
import Timer from "./Timer";

import {
  FacebookShareButton,
  FacebookIcon,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share';

import ReactHtmlParser from "react-html-parser";
import Reviews from "./Reviews.js";
import Question from "./Question.js";
import ReviewList from "./ReviewList.js";
import Cookies from "universal-cookie";
import auth from "../../../services/auth";
import moment from "moment";
import { appConfig } from "../../../config";
let rand = require("random-key");
const cookies = new Cookies();


const history = createHashHistory();
let isLoading = false,
  limit = 7;
class Dashboard extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      menuList: "",
      currentDeals: [],
      limit: 22,
      perPage: 22,
      total: "",
      topDealHighlights: "",
      button_color: '',
      text_color: "",
      mouseover_color: '',
      default_city: "",
      siteDomain: "",
      wdith: 0,
      height: 0,
      notifications: '',
      sending: false,
      pending_offers: '',
      upDeal: '',
      notFoundPopup: false,
      email: '',
      emailError: '',
      removePopup: true,
      hover: false,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.pagination = this.pagination.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }
 
  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }

  closenotFoundPopup = () => {
    this.setState({removePopup: false, total: ''});
  }
  pagination = () => {
    isLoading = true;
    limit = limit + this.state.perPage;
    const postData = {
      limit: limit,
      cityID : this.state.default_city,
      geolocation: "off",
      giftvoucher: "no",
    };

    this.props.currentDealList(postData);
  };

  handlePageChange = page => {
    isLoading = true;
    this.setState({
      currentPage: this.state.currentPage,
      sending: true
    });
    let default_city = this.state.default_city;
    let pending_offers = this.state.pending_offers;
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(!this.state.default_city || this.state.default_city != siteData.default_city){
      if(siteData && siteData.default_city){
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          pending_offers: siteData.pending_offers,
        });
        default_city = siteData.default_city;
        pending_offers = siteData.pending_offers;
      }
    }
    
    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      giftvoucher: "no",
    };

    if(default_city){
      postData.cityID = default_city;
    }
    if(!isEmpty(this.props.match.params) && this.props.match.params.cityID){
      postData.geolocation = "off";
    }
    
    if(this.state.geoCityId != this.state.default_city){
      postData.geolocation = "off";
    }

    this.props.currentDealList(postData);
    if(pending_offers == 'enable'){
      this.props.upcomingDealList(postData);
    }
  };

  onSearch = val => {
    this.handleSearch(val);
  };

  handleSearch(val) {
    const postData = {
      page: this.state.currentPage,
      latitude: this.props.coords ? this.props.coords.latitude : "26.846695",
      longitude: this.props.coords ? this.props.coords.longitude : "80.946167",
      search: val,
      geolocation: "off",
      giftvoucher: "no",
    };

    if (val.length !== 0) {
      this.props.currentDealList(postData);
    } else {
      this.handlePageChange();
    }
  }
  componentWillMount(){
    isLoading = true;
  }
  componentDidMount() {

    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          text_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }

    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({siteDomain: siteData.siteDomain});
      if(siteData.default_city){
        this.setState({
          default_city: siteData.default_city,
          notifications: siteData.notifications,
          geoCityId: (siteData.country && siteData.country.default_geo_city) ? siteData.country.default_geo_city : '',
        });
      }
    }else{
      // this.props.getSiteStatus();
    }
    this.handlePageChange(1);
    let userIDParams = this.props.match.params.user_ID
      ? this.props.match.params.user_ID
      : "";
    let Link = this.props.match.url;
    if (userIDParams !== "") {
      const token = auth.getToken();
      let d = new Date();
      d.setTime(d.getTime() + 480 * 60 * 1000);

      cookies.set("referredBy", userIDParams, { path: "/", expires: d });

      let url = appConfig.site.siteurl;
      cookies.set("referredLink", url + "/#" + Link, { path: "/", expires: d });
      let referredLink = cookies.get("referredLink");

      history.push({ pathname: "/" });

      if (token !== null) {
        let d = new Date();
        d.setTime(d.getTime() + 480 * 60 * 1000);
      }
    }

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);

    if(this.props.themeData.menu_bar){
      this.setState({
        menuBgStyles: {
          backgroundColor: this.props.themeData.menu_bar.menu_bar_color
        }
      })
    }else{
      this.setState({
        menuBgStyles: {
          backgroundColor: ''
        }
      })
    }
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillReceiveProps(nextProps) {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({notifications: siteData.notifications});
    }
    this.setState({sending: nextProps.sending});
    if(nextProps.match.params && nextProps.match.params.cityID && nextProps.match.params.cityID.length > 0  && nextProps.match.params.cityID != this.state.default_city){
      this.setState({
        default_city: nextProps.match.params.cityID
      });
      this.handlePageChange(1);
    }

    if((this.props.siteStatus != nextProps.siteStatus) && this.state.default_city == '' ){
      if(nextProps.siteStatus){
          this.handlePageChange(1);
      }
    }

    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          text_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

    if(nextProps.themeData.menu_bar){
      this.setState({
        menuBgStyles: {
          backgroundColor: nextProps.themeData.menu_bar.menu_bar_color
        }
      })
    }else{
      this.setState({
        menuBgStyles: {
          backgroundColor: ''
        }
      })
    }

    if (nextProps.curDeal  && this.state.default_city !== '') {
        this.setState({ total: (nextProps.curDeal.total) ? nextProps.curDeal.total : 0, notFoundPopup: false });
        this.setState({ curDeal: nextProps.curDeal.data });
        if(nextProps.curDeal && nextProps.curDeal.data && nextProps.curDeal.data.length > 0){
          let topDeals = nextProps.curDeal.data[0];
          topDeals.dealImages = nextProps.curDeal.data[0].top_deal_images;
          this.setState({ topDeal: topDeals, notFoundPopup: false });
          this.setState({ topDealHighlights: (nextProps.curDeal.data[0].highlights) ? JSON.parse(nextProps.curDeal.data[0].highlights) : '' });
        }else{
          this.setState({
            curDeal: '',
            topDeal: '',
            topDealHighlights: '',
            removePopup: true,
          });
        }
        isLoading = false;
    }else{
      this.setState({
        curDeal: '',
        topDeal: '',
        topDealHighlights: '',
        removePopup: true,
      })
    }



    if(this.state.pending_offers == 'enable'){
      if(this.props.upcomingDeal !== nextProps.upcomingDeal){
        if(nextProps.upcomingDeal){
          this.setState({upDeal: nextProps.upcomingDeal.data});
        }
      }
    }
    

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        isLoading = false;
      }
    }

  }

  shouldComponentUpdate(nextProps, nextState) {
      if ((this.state.curDeal === nextState.curDeal) && this.state.removePopup === false) {
          return false
      }
      return true
  }

  handleSelect(selectedIndex, e) {
    this.setState({
      index: selectedIndex,
      direction: e.direction
    });
  }
  submitSubscription = (e) => {
    e.preventDefault();
    if(this.state.email){
      let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
      if(siteData && siteData.default_city){
        const data = {
          city: [siteData.default_city],
          email: this.state.email,
          frequency: 'DAILY',
          geo_subscriber: 'yes',
        }
        this.props.subscribeUser(data);
      }
    }else{
      this.setState({emailError: 'red'});
    }
  }
  handleSubscribe = (e) => {
    if (`this.state.${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({[e.target.name] : e.target.value});
  }

  render() {
    const { index, direction, notifications } = this.state;
    let currentDeals, upDeal, totalDeal, utotalDeal, position;

    // Timer
    let timerOption = 'no';
    if(this.state.topDeal){
      let dt1 = new Date(this.state.topDeal.today_date); 
      let dt2 = new Date(this.state.topDeal.expiry_date); 

      let diff =(dt2.getTime() - dt1.getTime()) / 1000;
      diff /= (60 * 60);

      if(diff <= parseInt(this.state.topDeal.timerStartInHour) && this.state.topDeal.timerStartInHour > 0){
        timerOption = 'yes';
      }

      if(this.state.topDeal.timerStartInHour === '' ||  this.state.topDeal.timerStartInHour == 0){
        timerOption = 'yes';
      } 

      
    }
    // Internet Explorer 6-11
    const isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    const isEdge = !isIE && !!window.StyleMedia;



    if(this.state.pending_offers == 'enable' && !isEmpty(this.state.upDeal)){
      utotalDeal = this.state.upDeal.length;

      upDeal = this.state.upDeal.map((deal, index) => {
        return  <React.Fragment key={Math.random() + index}>
          <Col lg={4} md={4} sm={4} xs={12}>
            <div className="deal-container">
              <div className="deal-image">
                <Image
                  src={
                    deal.dealImage ? deal.imageurl +  deal.dealImage : noImg
                  }
                  alt={deal.img_alt_text}
                  title={deal.img_text}
                  description={deal.img_desc}
                  responsive
                />
              </div>
              <h2 className="dealname">{deal.mainDealText}</h2>
              <div className="merchant">
                {(deal.useProdName == 0) ? deal.merchantName : (deal.prodName) ? deal.prodName : deal.merchantName}
              </div>
              <div className="prices">
                {deal.offerPrice > 0 ? (
                  deal.offerPrice == deal.retailPrice ? (
                    <span className="percent" />
                  ) : (
                    <span className="percent" style={{ color: this.state.text_color }}>
                      -{(deal.offerPrice / deal.retailPrice * 100).toFixed(2)}%
                    </span>
                  )
                ) : (
                  <span className="percent" style={{ color: this.state.text_color }}>FREE</span>
                )}
                <span className="price">
                  <i className="fa fa-usd" />
                  {deal.retailPrice}
                </span>
                <span className="current">
                  <i className="fa fa-usd" />
                  {deal.offerPrice}
                </span>
              </div>
              <div className="short-disc">
                {!isEmpty(deal.writeUp)
                  ? ReactHtmlParser(deal.writeUp.substring(0, 180))
                  : ""}
              </div>
              <div className="deal-footer">
                <a
                  className="btn btn-deal"               
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {deal.dealID}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                >
                  Coming Soon
                </a>
              </div>
            </div>
          </Col>
        </React.Fragment>
      });
    }

    if (!isEmpty(this.state.curDeal)) {
      totalDeal = this.state.curDeal.length;
      if(totalDeal > 2){
        position = 2;
      }else{
        position = totalDeal - 1;
      }

      currentDeals = this.state.curDeal.map((deal, index) => {
        if(index > 0){
          return <React.Fragment key={Math.random() + index}>
          {(index == position) ?
            <React.Fragment>
            <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
              <div className="deal-container shadow">
                <div className="deal-image">
                  <Image
                    src={
                      deal.dealImage ? deal.imageurl + deal.dealImage : noImg
                    }
                    alt={deal.img_alt_text}
                    title={deal.img_text}
                    description={deal.img_desc}
                    responsive
                  />
                </div>
                <h2 className="dealname">{deal.mainDealText}</h2>
                <div className="merchant">
                  {(deal.useProdName == 0) ? deal.merchantName : (deal.prodName) ? deal.prodName : deal.merchantName}
                </div>
                <div className="prices">
                  {deal.offerPrice > 0 ? (
                    deal.offerPrice == deal.retailPrice ? (
                      <span className="percent" />
                    ) : (
                      <span className="percent" style={{ color: this.state.text_color }}>
                        -{(deal.offerPrice / deal.retailPrice * 100).toFixed(2)}%
                      </span>
                    )
                  ) : (
                    <span className="percent" style={{ color: this.state.text_color }}>FREE</span>
                  )}
                  <span className="price">
                    <i className="fa fa-usd" />
                    {deal.retailPrice}
                  </span>
                  <span className="current">
                    <i className="fa fa-usd" />
                    {deal.offerPrice}
                  </span>
                </div>
                <div className="short-disc">
                  {!isEmpty(deal.writeUp)
                    ? ReactHtmlParser(deal.writeUp.substring(0, 180))
                    : ""}
                </div>
                <div className="deal-footer">
                  {/*<a
                                      className="btn btn-deal"               
                                      style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                                      data-id = {deal.dealID}
                                      onMouseEnter={this.hoverOn} 
                                      onMouseLeave={this.hoverOff}
                                      onClick={() => (deal.offer_url) ? history.push(`/deals-detail/${deal.offer_url}`) : history.push(`/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`)}
                                    >
                                      View
                                    </a>*/}
                  {(isIE == false && isEdge == false) ?
                    <Link
                    className="btn btn-deal" 
                    data-id = {deal.dealID}
                    onMouseEnter={this.hoverOn} 
                    onMouseLeave={this.hoverOff}
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color, display: 'block'}}
                    key={Math.random()}
                    to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`} >
                        View
                    </Link>
                    :
                    <Link
                    className="btn btn-deal" 
                    data-id = {deal.dealID}
                    style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color, display: 'block'}}
                    key={Math.random()}
                    to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`} >
                        View
                    </Link>
                  }
                </div>
              </div>
            </Col>
            {(this.state.notifications) &&
              this.state.notifications.map((data, index) => 
                (data.position == 'third_position') &&
                  <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
                    <div className="deal-container shadow" key={Math.random() + index}>
                      <React.Fragment>
                      {(data.displayimage != '' || data.mobileappdisplay_image != '') ?
                        (this.state.width > 480 && data.remove_image == 1) ?
                          <a href={data.display_image_link} target="_blank"><Image src={data.displayimage} /></a>
                        :(this.state.width < 480 && data.remove_mobile_app_image == 1) ?
                        <a href={data.display_image_link} target="_blank"><Image src={data.mobileappdisplay_image} /></a>
                        :
                        <React.Fragment>{(data.message != '') ? ReactHtmlParser(data.message) : ''}</React.Fragment>
                      :
                        <React.Fragment>{(data.message != '') ? ReactHtmlParser(data.message) : ''}</React.Fragment>
                      }
                      </React.Fragment>
                    </div>
                  </Col>
              )
            }
            </React.Fragment>
          :
          <Col lg={4} md={4} sm={4} xs={12} key={Math.random() + index}>
            <div className="deal-container shadow">
              <div className="deal-image">
                <Image
                  src={
                    deal.dealImage ? deal.imageurl + deal.dealImage : noImg
                  }
                  alt={deal.img_alt_text}
                  title={deal.img_text}
                  description={deal.img_desc}
                  responsive
                />
              </div>
              <h2 className="dealname">{deal.mainDealText}</h2>
              <div className="merchant">
                {(deal.useProdName == 0) ? deal.merchantName : (deal.prodName) ? deal.prodName : deal.merchantName}
              </div>
              <div className="prices">
                {deal.offerPrice > 0 ? (
                  deal.offerPrice == deal.retailPrice ? (
                    <span className="percent" />
                  ) : (
                    <span className="percent" style={{ color: this.state.text_color }}>
                      -{(deal.offerPrice / deal.retailPrice * 100).toFixed(2)}%
                    </span>
                  )
                ) : (
                  <span className="percent" style={{ color: this.state.text_color }}>FREE</span>
                )}
                <span className="price">
                  <i className="fa fa-usd" />
                  {deal.retailPrice}
                </span>
                <span className="current">
                  <i className="fa fa-usd" />
                  {deal.offerPrice}
                </span>
              </div>
              <div className="short-disc">
                {!isEmpty(deal.writeUp)
                  ? ReactHtmlParser(deal.writeUp.substring(0, 180))
                  : ""}
              </div>
              <div className="deal-footer">
                {/*<a
                  className="btn btn-deal"               
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {deal.dealID}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  onClick={() => (deal.offer_url) ? history.push(`/deals-detail/${deal.offer_url}`) : history.push(`/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`)}
                >
                  View
                </a>*/} 
                {(isIE == false && isEdge == false) ?
                <Link
                className="btn btn-deal" 
                data-id = {deal.dealID}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color, display: 'block'}}
                key={Math.random()}
                to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`} >
                    View
                </Link>
                :
                <Link
                className="btn btn-deal" 
                data-id = {deal.dealID}
                style={{backgroundColor: (this.state.hover && this.state.hoverID == deal.dealID) ? this.state.mouseover_color : this.state.button_color, display: 'block'}}
                key={Math.random()}
                to={(deal.offer_url) ? `/deals-detail/${deal.offer_url}` : `/deals-detail/${deal.dealID}-${deal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`} >
                    View
                </Link>
                }
              </div>
            </div>
          </Col>
          }
          </React.Fragment>
      }});
    }
    return (
      <div>
        {(this.state.sending == true || isLoading == true) ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {!isEmpty(this.state.topDeal) && isLoading != true ? (
        <React.Fragment>
        <div className="container">
          {!isEmpty(this.state.topDeal) ? (
            <div className="bg-white slider-container shadow">
              <Row className="deal-banner">
              <Col lg={8} md={8} sm={6} xs={12}>
                {!isEmpty(this.state.topDeal.dealImages) ? (
                  <div className="dealSingleimage" style={{ backgroundImage: `url(${this.state.topDeal.dealImages[0].slider_image})`, backgroundPosition: "center", backgroundSize: "contain",  backgroundColor: "#fff"}}>
                    {/*<Image responsive src={this.state.topDeal.dealImages[0].slider_image} alt={this.state.topDeal.img_alt_text} title={this.state.topDeal.img_text}
                                      description={this.state.topDeal.img_desc} />*/}
                  </div>
                ) : (
                  <div className="dealSingleimage" >
                    <Image responsive src={noImg} />
                  </div>
                )}
              </Col>
              <Col lg={4} md={4} sm={6} xs={12}>
                <div className="bannerDeal text-center">
                  <h2 className="dealname">
                    {this.state.topDeal.mainDealText}
                  </h2>
                  <div className="merchant merchantname text-center">
                      {this.state.topDeal.merchantName}
                      <br/>
                      {(this.state.topDealHighlights.first) &&
                        this.state.topDealHighlights.first
                      }
                  </div>
                  <div className="deals-price">
                    <span className="price">
                      ${this.state.topDeal.offerPrice} 
                    </span>
                    <h5 className="merchant text-center">
                      {this.state.topDeal.shortTitle}
                    </h5>
                    {(isIE == false && isEdge == false) ?
                    <a
                      className="view-button btn btn-deal"
                      style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                      data-id = {this.state.topDeal.dealID}
                      onMouseEnter={this.hoverOn} 
                      onMouseLeave={this.hoverOff}
                      onClick={() =>
                        (this.state.topDeal.offer_url) 
                        ? 
                        history.push(`/deals-detail/${this.state.topDeal.offer_url}`) 
                        :
                        history.push(
                          `/deals-detail/${this.state.topDeal.dealID}-${this.state.topDeal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`
                        )
                      }
                    >
                      VIEW
                    </a>
                    :
                    <a
                      className="view-button btn btn-deal"
                      style={{backgroundColor: (this.state.hover && this.state.hoverID == this.state.topDeal.dealID) ? this.state.mouseover_color : this.state.button_color}}
                      data-id = {this.state.topDeal.dealID}
                      onClick={() =>
                        (this.state.topDeal.offer_url) 
                        ? 
                        history.push(`/deals-detail/${this.state.topDeal.offer_url}`) 
                        :
                        history.push(
                          `/deals-detail/${this.state.topDeal.dealID}-${this.state.topDeal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`
                        )
                      }
                    >
                      VIEW
                    </a>
                    }

                  </div>
                  
                  <div className="text-center">
                     <div className="valueInfo shadow">
                        <div className="value">
                          <p className="value">${this.state.topDeal.retailPrice}</p>
                          <p className="text">Value</p>
                        </div>

                        <div className="discount">
                          <p className="value">{this.state.topDeal.saving_percent}%</p>
                          <p className="text">Discount</p>
                        </div> 

                        <div className="save">
                          <p className="value">${this.state.topDeal.saving_amount}</p>
                          <p className="text">SAVINGS</p>
                        </div>
                      </div>
                  </div>
                  <div className="social-icons margin-top">
                    <FacebookShareButton className="facebook" quote={this.state.topDeal.mainDealText} url={`${this.state.siteDomain}/#/deals-detail/${this.state.topDeal.dealID}-${this.state.topDeal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}>
                    <FacebookIcon size={25} round={false} />
                    </FacebookShareButton>

                    <TwitterShareButton className="twitter" quote={this.state.topDeal.mainDealText} url={`${this.state.siteDomain}/#/deals-detail/${this.state.topDeal.dealID}-${this.state.topDeal.merchantName.toLowerCase().trim().split(/\s+/).join('-')}`}>
                    <TwitterIcon size={25} round={false} />
                    </TwitterShareButton>
                    {/*<a
                      href={this.state.topDeal.facebookPage}
                      className="facebook"
                    >
                      <i className="fa fa-facebook-square" />
                    </a>
                    <a
                      href={this.state.topDeal.twitterPage}
                      className="twitter"
                    >
                      <i className="fa fa-twitter-square" />
                    </a>*/}
                  </div>
                  {(this.state.topDeal.displayTimer == 1 && timerOption == "yes") &&
                    <div className="text-center timer">
                      <i className="fa fa-clock-o" />{" "}
                      {this.state.topDeal.time_remaining}
                    </div>
                  }
                </div>
                {/*(this.state.topDealHighlights && (this.state.topDealHighlights.first || this.state.topDealHighlights.second || this.state.topDealHighlights.third || this.state.topDealHighlights.fourth)) ? (
                  <span>
                  <hr />
                  <h3>Deal Highlights</h3>
                  <div className="highlights">
                    <ul>
                      {(this.state.topDealHighlights.first) &&
                      <li key={Math.random()}>{this.state.topDealHighlights.first}</li>
                      }
                      {(this.state.topDealHighlights.second) &&
                      <li key={Math.random()}>{this.state.topDealHighlights.second}</li>
                      }
                      {(this.state.topDealHighlights.third) &&
                      <li key={Math.random()}>{this.state.topDealHighlights.third}</li>
                      }
                      {(this.state.topDealHighlights.fourth) &&
                      <li key={Math.random()}>{this.state.topDealHighlights.fourth}</li>
                      }
                    </ul>
                  </div>
                  </span>
                ) : null */}
              </Col>
            </Row>
            </div>
            
          ) : null}
        </div>

        <div className="container">
          {/*<div className="heading">
            <h2 style={{background:'#111', color:'#fff'}}>Current Deals</h2>
          </div>*/}
          <Row className="dealflex">{currentDeals}</Row>
          {this.state.total > totalDeal ? (
            <Row>
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                onClick={this.pagination}
                className="text-center"
              >
                <a 
                className="btn btn-deal" 
                style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Load More') ? this.state.mouseover_color : this.state.button_color}}
                data-id = {'Load More'}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                >
                Load More Deals
                </a>
              </Col>
            </Row>
          ) : null}
        </div>
        {(this.state.pending_offers == 'enable'  && !isEmpty(this.state.upDeal)) &&
        <div className="container">
          <div className="heading" style={this.state.menuBgStyles}>
            <h2 style={{color:'#fff'}}>Upcoming Deals</h2>
          </div>
          <Row>{upDeal}</Row>
        </div>
        }
        </React.Fragment>
        ):('')}
        {isEmpty(this.state.topDeal) && isLoading != true ? (
          <React.Fragment>
          <Row>
            <Col lg={12} md={1} sm={12} xs={12}>
              <Image src={noRecordFound} responsive style={{margin: 'auto'}}/>
            }
            </Col>
          </Row>
          <Modal show={(this.state.total === 0 && isLoading == false) ? this.state.removePopup : false} onHide={this.closenotFoundPopup.bind(this)}>
            <Modal.Header closeButton>
              <Modal.Title>{" "}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <h1>Sorry, we currently don’t have any offers in this market!</h1>
              <h4>We hope to have more in soon!</h4>
              <Form inline className="subscription">
                <FormGroup controlId="formInlineName">
                  <ControlLabel>Don't miss out! Get on our list: </ControlLabel>{' '}
                  <FormControl 
                    type="text" 
                    name="email"
                    onChange={this.handleSubscribe}
                    autoComplete="off"
                    style={{borderColor: this.state.emailError}}
                    />
                </FormGroup>{' '}
                <Button 
                  type="submit" 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == "dealSubscribe") ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {"dealSubscribe"}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  className="cursor" onClick={this.submitSubscription}
                >
                  Send a Request
                </Button>
              </Form>
            </Modal.Body>
            <Modal.Footer>
            {' '}
            </Modal.Footer>
          </Modal>
          </React.Fragment>
        ):('')}
      </div>
    );
  }
}

// export default Dashboard;

Dashboard.propTypes = {
  currentDealList: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  curDeal: state.frontReducer.curDeal,
  error: state.frontReducer.error,
  sending: state.frontReducer.sending,
  siteStatus: state.siteReducer.siteStatus,
  upcomingDeal: state.frontReducer.upcomingDeal,
  subscribeStatus: state.frontReducer.subscribeStatus,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    currentDealList, getSiteStatus, upcomingDealList, subscribeUser
  })
)(Dashboard);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Dashboard.js